/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Person2Outlined } from "@mui/icons-material";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { InformacionInicialRoles } from "store/roles/rolesActions";

export default function CardProcesos({ numero, titulo, pasos, roles, onHoverEnter, onHoverLeave }) {
  const dispatch = useDispatch();
  useEffect(() => {
    InformacionInicialRoles(dispatch);
  }, []);
  const rolesUsuarios = useSelector((state) => state.roles.rolesUsuarios);
  return (
    <Box
      onMouseEnter={onHoverEnter}
      onMouseLeave={onHoverLeave}
      sx={{ position: "relative", width: 400 }}
    >
      {/* Título flotante */}
      <Box
        sx={{
          position: "absolute",
          top: -20,
          left: "50%",
          transform: "translateX(-50%)",
          background: "linear-gradient(135deg, #605CA9, #5873B8)",
          color: "#000",
          px: 3,
          py: 1,
          borderRadius: 2,
          boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          fontWeight: "bold",
          fontSize: 16,
          textAlign: "center",
          zIndex: 1,
          width: 300,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textTransform: "uppercase",
            margin: 0,
          }}
        >
          Paso {numero}: {titulo}
        </Typography>
      </Box>

      {/* Card principal */}
      <Card
        sx={{
          height: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          pt: 5, // espacio para que no tape el título
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <CardContent>
          {/* Contenido del paso */}
          <Box sx={{ mb: 2 }}>
            {pasos.map((paso, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: "14px",
                  color: "#E0E0E0",
                  mb: 0.5,
                }}
              >
                {paso}
              </Typography>
            ))}
          </Box>

          {/* Roles */}
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {roles.map((rol, index) => {
              const usuarioRol = rolesUsuarios.find((rc) => rc.idRolUsuario === rol) || null; // color por defecto

              return (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    bgcolor: `${usuarioRol ? usuarioRol.colorRol : "#555"}`,
                    borderRadius: 1,
                    px: 1,
                    py: 0.5,
                  }}
                >
                  <Person2Outlined
                    sx={{
                      fontSize: 16,
                      color: "#1E1E2F",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#1E1E2F",
                    }}
                  >
                    {usuarioRol ? usuarioRol.rolUsuario : "Rol de usuario"}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
